import React from "react";
import { motion } from "framer-motion";
import { fadeUp, lineChild, staggerParent, viewportOnce } from "@/lib/anim";

// Masked, line-by-line reveal. Pass an array of strings (lines).
export const MaskedLines = ({
    lines = [],
    className = "",
    lineClassName = "",
    as: Tag = "h2",
    delayChildren = 0.05,
    stagger = 0.14,
    animateOnLoad = false,
}) => {
    const motionProps = animateOnLoad
        ? { initial: "hidden", animate: "show" }
        : { initial: "hidden", whileInView: "show", viewport: viewportOnce };

    return (
        <Tag className={className}>
            <motion.span
                variants={staggerParent(stagger, delayChildren)}
                {...motionProps}
                style={{ display: "block" }}
            >
                {lines.map((line, i) => (
                    <span key={i} className="reveal-mask">
                        <motion.span
                            variants={lineChild}
                            className={`block ${lineClassName}`}
                        >
                            {line}
                        </motion.span>
                    </span>
                ))}
            </motion.span>
        </Tag>
    );
};

// Simple fade-up on scroll.
export const FadeUp = ({ children, className = "", delay = 0, ...rest }) => (
    <motion.div
        className={className}
        variants={fadeUp}
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        transition={{ delay }}
        {...rest}
    >
        {children}
    </motion.div>
);
